/*
* cправочник соответствия id табличных данных о детализации (движение, простой, перерыв ...)
* цветам из макета
* */

export const dataPresentationPalette = {
    3: "#689ADB",   // Всего - значение с бэка #4373C5
    4: "#1565C0",   // Время активности прибора - значение с бэка #ED7D31
    5: "#009688",   // Движение - значение с бэка #A5A5A5
    6: "#8BC34A",   // В том числе на транспорте - значение с бэка #FFBF00
    7: "#FFC107",   // В том числе пешком - значение с бэка #6898BE
    8: "#FF9800",   // Активность без передвижения - значение с бэка #70AD46
    9: "#F44336",   // Чистый простой - значение с бэка #264478
    10: "#AD1457",  // Обеденный перерыв - значение с бэка #8A5022
}